module.exports = __webpack_public_path__ + "img/maurizio_.565aee2d.jpg";